import { FlexRow } from '@/components/common/Flex';
import { Header } from '@/components/common/Typography';
import { Center, CenterProps } from '@chakra-ui/react';
import { CheckCircle } from '../common/icons';

export interface TransactionCompleteCardProps extends CenterProps {
    onClose: VoidFunction;
    title: string;
}

const TransactionCompleteCard = ({
    onClose,
    title,
    ...props
}: TransactionCompleteCardProps) => {
    setTimeout(() => onClose(), 2500); // auto-close modal after 2.5 seconds

    return (
        <Center h="full" {...props}>
            <FlexRow align="center" color="blue.500">
                <CheckCircle size={10} mr={4} />
                <Header>{title}</Header>
            </FlexRow>
        </Center>
    );
};

export default TransactionCompleteCard;
